module.exports = __webpack_public_path__ + "5fe339b5886fe392b7b858955e8f4c27.png";